<template>
  <div>
    <el-form ref="form" :model="formData" :rules="rules" size="small">
      <el-form-item prop="listScmContactSeqno">
        <dict-select
          v-model="formData.listScmContactSeqno"
          :placeholder="
            $l('form_placeholder_scmContactSeqno') || '请选择联系人'
          "
          :body="scmSelectBody"
          url="/digitalCenter/scmInfoContacts/select"
          clearable
          filterable
          multiple
          style="width: 100%"
          @loaded="loaded"
        />
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import lodash from 'lodash'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    scmCode: { type: String, default: '' },
    listAmzPurchaseCode: { type: Array, default: () => [] },
  },
  data() {
    return {
      formData: { listScmContactSeqno: [] },
      scmSelectBody: { scmCode: this.scmCode },
      rules: {
        listScmContactSeqno: [
          {
            required: true,
            message:
              this.$l('form_placeholder_scmContactSeqno') || '请选择联系人',
            trigger: 'change',
          },
        ],
      },
    }
  },
  watch: {
    scmCode(val) {
      this.scmSelectBody = { scmCode: val }
    },
  },
  methods: {
    loaded(items) {
      const length = items?.length || 0
      if (!length || length > 1) return

      const item = lodash.first(items)
      if (!item) return

      this.formData.listScmContactSeqno = [item.value]
    },
    async send() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return

      const params = {
        ...this.formData,
        scmCode: this.scmCode,
        listAmzPurchaseCode: this.listAmzPurchaseCode,
      }

      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomAmzFtyPurchaseSendContractApi(params)
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status, msg } = res
      if (status !== 200) {
        this.$message.error(msg)
        return
      }

      this.$message({
        showClose: true,
        message: res.msg,
        type: 'success',
      })
      this.$emit('success')
      this.close()
    },
    close() {
      this.$emit('close')
    },
  },
}
</script>
